import ButtonsContainer from "../general/ButtonsContainer";
import { Button } from "@yoast/ui-library";
import { defineMessages, FormattedMessage } from "react-intl";
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/react/20/solid";
import * as styles from "./InstallStyles.scss";
import { SkipInstallationFlowLink } from "./SkipInstallationFlowLink";
import React, { useContext } from "react";
import { InstallContext } from "./InstallContext";


const messages = defineMessages( {
	continueButton: {
		id: "install.button.continue",
		defaultMessage: "Continue",
	},
	back: {
		id: "install.button.back",
		defaultMessage: "Back",
	},
} );

export const StepNavigation = () => {
	const { steps, goToNextStep, goToPreviousStep } = useContext( InstallContext );

	return <>
		<ButtonsContainer className={ styles.buttonContainer }>
			{ steps.canGoBack && <Button variant={ "tertiary" } onClick={ goToPreviousStep }>
				<ArrowLongLeftIcon className={ styles.buttonIcon } />
				<FormattedMessage { ...messages.back } />
			</Button> }
			<Button onClick={ goToNextStep }>
				<FormattedMessage { ...messages.continueButton } />
				<ArrowLongRightIcon className={ styles.buttonIcon } />
			</Button>
		</ButtonsContainer>
		<SkipInstallationFlowLink />
	</>;
};
